

exports.__esModule = true;

var _consent = require('./consent');

Object.keys(_consent).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _consent[key];
    }
  });
});

var _userAgreementConsent = require('./userAgreementConsent');

Object.keys(_userAgreementConsent).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _userAgreementConsent[key];
    }
  });
});


//////////////////
// WEBPACK FOOTER
// ../node_modules/xo-models/src/consent/index.js
// module id = ../node_modules/xo-models/src/consent/index.js
// module chunks = 0